import AddEventModal from "./add-event-modal.vue";

export default AddEventModal;



// WEBPACK FOOTER //
// ./src/components/_modals/add-event/index.js